<template>
  <div class="detail-page">
    <div class="nav"  style="flex-direction: row;">
      <div class="">
        <span class="back-realm" @click="goBack"
          >{{ role == 2 ? '实时监测' : '首页' }} ></span
        >
        <span> {{ navText2 }}</span>
      </div>
      <div class="back" @click="goBack">
        <a-icon type="left-circle" />
        返回
      </div>
    </div>
    <div class="page-top">
      <DetaliPageTitle
        v-if="isShowTitle"
        :pageTitleData="pageTitleData"
        :pageTitlRoomName="pageTitlRoomName"
        @changeDefaultBed="changeDefaultBed"
      ></DetaliPageTitle>
      <div class="page-content">
        <DetaliPageConRoom
          :detailPageData="detailPageData"
					:pageBottomData="pageBottomData"
          @getHistoryList="getRoomListById"
          v-if="detailPageData.radarType === 1 && isShowRoom"
        ></DetaliPageConRoom>
        <DetaliPageConToitet
          v-if="isShowRoomToilet && detailPageData.radarType === 2"
          :bedId="detailPageBedId"
        ></DetaliPageConToitet>
		<DetaliPageBtn
		  v-if="isShowBtnPage && detailPageData.radarType === 3"
		  :bedId="detailPageBedId"
		></DetaliPageBtn>
      </div>
    </div>
    <DetaliPageBottom
      v-if="isShowBottom && detailPageData.radarType === 1"
      :pageBottomData="pageBottomData"
      @openHealthy="openHealthy"
    ></DetaliPageBottom>
    <Healthy ref="healthy" />
	<AiReport v-if="this.$store.state.aiSingleReportData && this.$route.path.indexOf('protect/realTimeMonitoringtwo') >= 0" :itemData="this.$store.state.aiSingleReportData"  />
  </div>
</template>
<script>
import Healthy from './../../component/healthy/healthy.vue';
import DetaliPageTitle from './../../component/detaliPage/detaliPageTitle.vue';
import DetaliPageBottom from './../../component/detaliPage/detaliPageBottom.vue';
import DetaliPageConToitet from './../../component/detaliPage/detaliPageConToitet.vue';
import DetaliPageConRoom from './../../component/detaliPage/detaliPageConRoom.vue';
import DetaliPageBtn from './../../component/detaliPage/detaliPageBtn.vue';
import AiReport from "../dean/aiReport.vue";
export default {
  components: {
    DetaliPageTitle,
    DetaliPageBottom,
    DetaliPageConToitet,
    DetaliPageConRoom,
	DetaliPageBtn,
    Healthy,
	AiReport
  },
  data() {
    return {
      role: 2,
      pageTitleData: [],
      pageTitlRoomName: '',
      pageBottomData: {},
      detailPageData: {},
      isShowBottom: false,
      isShowTitle: false,
      isShowRoom: true,
      isShowRoomToilet: false,
	  isShowBtnPage: false,
      detailPageBedId: 0,
      navText: '',
      navText2: '',
      activeDates: [],
      
      // 进入实时界面调用切换算法并做日志记录接口内容
      oldSnCode: '',
      newSnCode: '',
      timeRefName: null,
      nowPageTime: 0,       //当前页面时间，用于计时
    };
  },
  created() {
    this.getActiveDates();
    console.log();
    this.getRoomListById();
    this.role = this.$getCookie('userInfo').user.roleId;
  },
  mounted() {},
  methods: {
    // 进入实时界面调用切换算法并做日志记录接口
    intoRealTimeOb(nowSn,type){
      let params = {
        clientType: 1,        //0.不区分1.web端2.小程序3.APP4.公众号 ClientTypeEnum 枚举
        operationType: type,    //操作类型 0续期 1.进入 2.返回 3.继续4.退出
        pageType: 1000,         //业务类型(哪个页面) BrowsePageTypeEnum 枚举
        snCode: nowSn,
      };
      this.$post(
        '/api/app/v1/intoRealTimeOb',
        params,
        (res) => {
          if (res.code === 0) {
            if(type == 1){      //如果走的是进入类型，开始计时。调持续
            //   this.timeRefresh();
            }
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    // timeRefresh(){
    //   console.log('我想先清除定时器')
    //   clearInterval(this.timeRefName);
    //   this.timeRefName = null
    //   this.nowPageTime = 0;
    //   console.log(this.timeRefName)
    //   if(!this.timeRefName){
    //     this.timeRefName = setInterval((res) => {
    //       this.nowPageTime += 1
    //       console.log(this.nowPageTime)
    //       if(this.nowPageTime == 60){       //若计时1分钟了
    //         this.nowPageTime = 0;
    //         this.intoRealTimeOb(this.newSnCode,0)
    //       }
    //     },1000)
    //   }
      
    //   // 通过 $once 来监听定时器，在 beforeDestroy 钩子可以被清除。
    //   this.$once('hook:beforeDestroy', () => {            
    //     clearInterval(this.timeRefName);   
    //     this.timeRefName = null;
    //   })
    // },
    goBack() {
      if (this.role == '3') {
        this.$router.push({
          path: '/protect/home',
        });
      } else if (this.role == '2') {
        this.$router.push({
          path: '/dean/realTimeMonitor',
        });
      }
    },
    getRoomListById() {
      let params = {
        roomId: this.$route.query.roomId,
      };
      this.$get(
        '/api/v3/bed/getRoomListById',
        params,
        (res) => {
          if (res.code === 0) {
            if (!res.data) {
              return;
            }
            console.log(res.data);
            this.getBedInfoById(res.data.defaultBedId);
            this.pageTitleData = res.data.bedList;

            this.pageTitlRoomName = res.data.roomName;
            this.isShowTitle = true;
            this.navText = res.data.buAndFlName + '-' + res.data.roomName;
            res.data.bedList.forEach((item) => {
				if (item.bedId === res.data.defaultBedId && item.hasDefault && item.hasDefault == true) {
					if (item.radarType == 3) {
						this.detailPageData = item;
						this.detailPageBedId = item.bedId;
						this.isShowBtnPage = true;
					} else if (item.radarType == 2) {
						this.detailPageData = item;
						this.detailPageBedId = item.bedId;
						this.isShowRoomToilet = true;
					} else {
						this.detailPageData = item;
						this.detailPageBedId = item.bedId;
						this.isShowBottom = true;
					}
              	}
            });

            this.navText2 = `${this.navText}`;
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    getBedInfoById(bedId) {
      let params = {
        bedId: bedId,
      };
      this.$get(
        '/api/v3/bed/getBedInfoById',
        params,
        (res) => {
          if (res.code === 0) {
            if (!res.data) {
              return;
            }
            this.isShowBottom = false;
            this.pageBottomData = [];
            this.pageBottomData = res.data;
            setTimeout(() => {
              this.isShowBottom = true;
            }, 0);
            console.log('基本信息', res.data);




            // 用于进入实时界面调用切换算法并做日志记录接口
            console.log(this.detailPageData.radarType)
            if(this.detailPageData.radarType == 1){
              if(!this.oldSnCode){        //第一次进来，没有老sn
                this.oldSnCode = res.data.sn
              }else{    
                this.oldSnCode = this.newSnCode     //取上一次操作的最新sn
                this.intoRealTimeOb(this.oldSnCode,4)
              }
              this.newSnCode = res.data.sn;
              this.intoRealTimeOb(this.newSnCode,1)
            }
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    changeDefaultBed(data) {
      this.isShowRoom = false;
      this.isShowRoomToilet = false;
	  this.isShowBtnPage = false;
      this.detailPageData = this.pageTitleData[data];
      console.log(this.detailPageData);

      this.detailPageBedId = this.detailPageData.bedId;
      setTimeout(() => {
        this.isShowRoom = true;
        this.isShowRoomToilet = true;
		this.isShowBtnPage = true;
      });

      this.navText2 = `${this.navText}`;
      this.getBedInfoById(this.detailPageData.bedId);
    },
    openHealthy(data) {
      console.log(
        data,
        this.activeDates,
        'dataopenHealthyopenHealthyopenHealthy'
      );
      this.$refs.healthy.details({
        bedId: data.bedId,
        bedName: data.bedName,
        activeType: 1,
        activeDate: this.activeDates[0],
        activeDate: this.activeDates[0],
        sn: data.sn,
      });
    },
    getActiveDates() {
      var day = new Date();
      var time = day.getTime();
      for (var i = 0; i <= 29; i++) {
        var ms = 24 * 3600 * 1000 * i;
        day.setTime(parseInt(time - ms));
        var y = day.getFullYear().toString();
        var m = (day.getMonth() + 1).toString();
        if (m.length <= 1) m = '0' + m;
        var d = day.getDate().toString();
        if (d.length <= 1) d = '0' + d;
        this.activeDates[i] = y + '-' + m + '-' + d;
      }
      console.log(this.activeDates);
    },
  },
  beforeDestroy() {
    this.intoRealTimeOb(this.newSnCode,4)
  },
};
</script>
<style lang="scss" scoped>
.detail-page {
  height: 600px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  .nav {
    width: 100%;
    height: 54px;
    position: absolute;
    top: 80px;
    left: 0;
    background: red;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 40px;
    background: rgba(255, 255, 255, 0.6);
    box-shadow: 0px 1px 4px -2px rgba(0, 0, 0, 0.5);
    .back {
      color: #1890ff;
      cursor: pointer;
      line-height: 20px;
    }
    .back-realm {
      color: #8c8c8c;
      cursor: pointer;
    }
  }
  .page-top {
    width: 100%;
    flex: 1;
    margin-bottom: 10px;
    margin-top: 70px;
    .title {
      width: 100%;
      height: 65px;
      display: flex;
      align-items: center;
      .title-left {
        width: 120px;
        height: 65px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #1890ff;
        color: #fff;
        font-size: 20px;
        font-weight: 400;
        border-radius: 8px 32px 32px 0px;
      }
      .title-right {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-around;
        .item {
          width: 140px;
          height: 45px;
          background: #e6f7ff;
          border-radius: 23px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
          font-weight: 400;
          color: #1890ff;
          .bed-icon {
          }
        }
      }
    }
    .page-content {
      width: 1240px;
    }
  }
}
</style>
